<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="thumb-down">
      <path id="Union" d="M10 9.77344H13.2192C13.8698 9.77344 14.3472 9.16205 14.1894 8.5309L12.6894 2.5309C12.5781 2.08573 12.1781 1.77344 11.7192 1.77344L3 1.77344C2.44772 1.77344 2 2.22115 2 2.77344L2 7.77344C2 8.32572 2.44772 8.77344 3 8.77344L5 8.77344L7 13.7734H9C9.55229 13.7734 10 13.3257 10 12.7734V9.77344ZM6 8.58086L6 2.77344L11.7192 2.77344L13.2192 8.77344H9L9 12.7734H7.67703L6 8.58086ZM5 7.77344L3 7.77344L3 2.77344L5 2.77344L5 7.77344Z" fill="currentColor"/>
    </g>
  </svg>
</template>